import React from "react";
import Vimeo from '@u-wave/react-vimeo';
import '../assets/templates/VideoSubtitle.css';

const VideoSubtitle = props => {
  const { paused, blockData } = props;

  return (
    <div className="default-card">
      <div className=''>
        {blockData.complement.video_id ? (
          <>
            <div className="video-subtitle-title">
              {blockData.complement.titulo}
            </div>
            <div className="video-subtitle-container-video">
              <Vimeo
                responsive={true}
                paused={paused}
                video={"https://player.vimeo.com/video/" + blockData.complement.video_id.split('/').pop()}
                onError={() => {}}
              />
            </div>
            {blockData.complement.instruction &&
              <div className="video-subtitle-instruction">
                {blockData.complement.instruction}
              </div>
            }
          </>
        ) : (
          <div>No video available</div>
        )
        }
      </div>
    </div>
  );
}

export default VideoSubtitle;